// Public (no login) — sends a Services-page enquiry form to the backend, which
// turns it into a lead with source "Website - <Service>".
export async function submitServiceEnquiry(service, data) {
  const res = await fetch('/api/service-enquiries', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ service, ...data }),
  });
  let payload = null;
  try {
    payload = await res.json();
  } catch (_) {}
  if (!res.ok || !payload?.success) {
    throw new Error(payload?.message || 'Could not submit your enquiry. Please try again.');
  }
  return payload;
}
